import React, { useEffect } from "react";

import Colors from "../colors";
import ReactDOMServer from "react-dom/server";
import useLeaflet from "../hooks/useLeaflet";

const L: any = require("leaflet");
L.esri = require("esri-leaflet");

const labels = {
  allYear: {
    da: "Hele året",
    en: "All year",
    de: "Ganzjährig",
  },
  special: {
    da: "16. september - 15. marts",
    en: "September 16 - March 15",
    de: "16. September - 15. März",
  },
  protectedZone: {
    da: "Fredningszone",
    en: "Conservation Zone",
    de: "Schutzzone",
  },
  fishingProhibited: {
    da: "Fiskeri forbudt i perioden",
    en: "Fishing prohibited during the period",
    de: "Fischen während der Periode verboten",
  },
  readMore: {
    da: "Læs mere",
    en: "Read more",
    de: "Weiterlesen",
  },
  protected: {
    da: "Fredet",
    en: "Protected",
    de: "Geschützt",
  },
};

const featureServerURL =
  "https://services-eu1.arcgis.com/1PSnmNDZsplHdhAh/ArcGIS/rest/services/Hav%c3%b8rred_Limfjorden___opdatering_af_kort_2023/FeatureServer/2";

/**
 * This component displays the fredningszoner on the map
 */

const Fredningszoner = (props) => {
  const context = useLeaflet();

  useEffect(() => {
    if (!context) return;

    const layer = L.esri
      .featureLayer({
        //fredningszoner
        url: featureServerURL,
        style: (feature) => {
          let periode = feature.properties.FREDNINGSP;
          //console.log(feature);
          //æøå problemer her....
          let fredningsColor;
          if (periode === "Hele året") {
            fredningsColor = Colors.fredningsRed;
            feature.properties.FREDNINGSP = labels.allYear[props.language];
          } else if (periode === "16. september - 15. marts") {
            fredningsColor = Colors.fredningsBlue;
            feature.properties.FREDNINGSP = labels.special[props.language];
          } else {
            fredningsColor = Colors.fredningsYellow;
            feature.properties.FREDNINGSP = feature.properties.FREDNINGSP.replace(
              "�",
              "æ"
            );
          }

          return { color: fredningsColor };
        },
      })
      .bindPopup((layer) => {
        //set popup på fredningszoner
        let period = layer.feature.properties.FREDNINGSP;
        let url = layer.feature.properties.WWW;
        return ReactDOMServer.renderToStaticMarkup(
          <div>
            <b>{labels.protectedZone[props.language]}</b>
            <br />
            {labels.fishingProhibited[props.language]}: {period} <br />
            <a href={url} target="_blank" rel="noopener noreferrer">
              {labels.readMore[props.language]}
            </a>
          </div>
        );
      })
      .bindTooltip((layer) => {
        //set tooltip på fredningszoner
        let period = layer.feature.properties.FREDNINGSP;
        return labels.protected[props.language] + ": " + period;
      });

    layer.addTo(context.map);
    return () => {
      context.map.removeLayer(layer);
    };
  }, [props.language]);

  return null;
};

export default Fredningszoner;
